import { Directive } from '@angular/core';

@Directive({
    selector: '[tidyCarrousel]',
    standalone: false
})
export class TidyCarrouselDirective {}
